// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCdWf3FvBsNuTD1VZzmw1D_uRZjinADIY4",
  authDomain: "meal-planner-2966f.firebaseapp.com",
  projectId: "meal-planner-2966f",
  storageBucket: "meal-planner-2966f.firebasestorage.app",
  messagingSenderId: "41563661447",
  appId: "1:41563661447:web:626985e5d1516493704422"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);